module.exports = __webpack_public_path__ + "media/footer/fastweb30-footer-bbc660cb.svg";